import { Card, CompartmentCard } from "@/src/components/cards";
import { FetchableList } from "@/src/components/fetchableLists";
import { Input } from "@/src/components/universalInput";
import { CardType, Consigne, FolderItem, Patient } from "@/src/data/allTypes";
import { USER } from "@/src/data/globalVariables";
import apiFetch from "@/src/utils/apiFetch";
import {
  fromNow,
  getItemId,
  getUserId,
  getUserShortName,
} from "@/src/utils/utils";
import { useState } from "react";
import { openDrawer } from "../../components/dialogs";
import { getStandardConfidentiality } from "../patients/confidentialitiesHook";

function ConsignesCompartment({
  color,
  patient,
  parent,
}: {
  color?: CardType;
  patient: Patient;
  parent: FolderItem;
}) {
  let [searchKey, setSearchKey] = useState("");
  const [reload, setReload] = useState(0);
  return (
    <CompartmentCard
      title="Consignes et remarques"
      color={color || "purple"}
      onClick={async () => {
        let consigne: Consigne = {
          type: "consigne",
          patient,
          creator: getUserId(),
          readBy: [getUserId()],
          parent: parent,
          confidentiality: getStandardConfidentiality(patient),
          uploads: [],
        };

        await openDrawer({
          id: "consignesDrawer",
          title: "Consignes",
          content: (
            <ConsigneForm
              current={consigne}
              onChange={(newValue) => {
                consigne = newValue;
              }}
            />
          ),
          onConfirm: async (e) => {
            let result = await apiFetch("consignes", "addOne", {
              consigne,
            });
            if (!result) return;
            consigne = result;
            setReload((prev) => prev + 1);
          },
        });
      }}
    >
      <FetchableList
        queryKey={[
          "ConsignesCompartment",
          searchKey,
          parent.id,
          USER.get()?.id,
          reload,
        ]}
        queryFn={() =>
          apiFetch("consignes", "loadMany", {
            patientId: patient.id,
            parentId: parent.id,
          })
        }
      >
        {(data) => (
          <div className="grid c1 gap10">
            {data?.map((consigne) => {
              return (
                <Card
                  key={consigne.id}
                  color={color || "purple"}
                  title={getUserShortName(consigne.creator)}
                  leading={<> </>}
                  onDelete={async () => {
                    await apiFetch("consignes", "deleteOne", {
                      rowId: getItemId(consigne),
                    });
                    setReload((prev) => prev + 1);
                  }}
                >
                  <div>{consigne.notes}</div>
                  <div className="gray">{fromNow(consigne._date)}</div>
                </Card>
              );
            })}
          </div>
        )}
      </FetchableList>
    </CompartmentCard>
  );
}

function ConsigneForm({
  current,
  onChange,
}: {
  current?: Consigne;
  onChange: (newValue: Consigne) => void;
}) {
  let [data, setData] = useState(current || ({} as Consigne));
  function setNewValue(newValue: Consigne) {
    setData(newValue);
    onChange(newValue);
  }

  return (
    <div className="grid gap10 c1">
      <Input
        name={"Texte"}
        placeholder="Texte libre"
        type={"textarea"}
        rows={10}
        value={data.notes}
        onChange={(newValue) => {
          setNewValue({ ...data, notes: newValue });
        }}
      />
    </div>
  );
}

export { ConsigneForm, ConsignesCompartment };
